import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";

import PagerHeaderComp from "../sharedLandingcomponents/PagesHeaderComp";
import ContactComp from "../sharedLandingcomponents/Contact_Comp";
import MotionCompGeneral from "../sharedLandingcomponents/Motion_Comp";

const ContactPage = () => {
  const contacts = [
    {
      icon: <PhoneOutlined />,
      title: "Call Us",
      value: "+234 807 338 8263",
      link: "tel:+2348073388263",
    },
    {
      icon: <MailOutlined />,
      title: "Email",
      value: "info@suparecords.ng",
      link: "mailto:info@suparecords.ng",
    },
    {
      icon: <EnvironmentOutlined />,
      title: "Office",
      value: "Osubi, Delta State, Nigeria",
    },
    {
      icon: <CustomerServiceOutlined />,
      title: "Support",
      value: "24/7 Customer Support",
    },
  ];

  return (
    <div className="bg-slate-50">

      <PagerHeaderComp
        title="Contact Us"
        subTitle="Let's build something amazing together."
      />

      {/* Contact Cards */}

      <section className="py-20">

        <div className="max-w-7xl mx-auto px-6">

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">

            {contacts.map((item, index) => (

              <div
                key={index}
                className="rounded-3xl bg-white border border-gray-200 p-8 shadow-lg hover:-translate-y-2 transition"
              >
                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-red-600 to-orange-500 text-white text-3xl">

                  {item.icon}

                </div>

                <h3 className="mt-6 text-2xl font-bold">

                  {item.title}

                </h3>

                {item.link ? (

                  <a
                    href={item.link}
                    className="mt-4 block text-gray-600 hover:text-red-600"
                  >
                    {item.value}
                  </a>

                ) : (

                  <p className="mt-4 text-gray-600">

                    {item.value}

                  </p>

                )}

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* Intro */}

      <section className="pb-16">

        <div className="max-w-4xl mx-auto px-6 text-center">

          <MotionCompGeneral
            showMoveLeft
            showMoveRight
            showRotateRight
            rotateRightImg={`${process.env.PUBLIC_URL}/images/homePage/spec-el-2.png`}
          />

          <h2 className="text-5xl font-black text-slate-900">

            We'd Love To Hear From You

          </h2>

          <p className="mt-8 text-lg text-gray-600 leading-9">

            Whether you're interested in inventory management,
            accounting, warehouse management, or a customized
            enterprise solution, our team is here to help.

          </p>

        </div>

      </section>

      {/* Contact Form */}

      <section className="pb-24">

        <div className="max-w-7xl mx-auto px-6">

          <div className="rounded-[36px] bg-white shadow-xl border border-gray-200 p-10">

            <ContactComp />

          </div>

        </div>

      </section>

      {/* Google Map */}

      {/* <section>

        <iframe
          src="YOUR GOOGLE MAP URL"
          width="100%"
          height="550"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          title="SupaRecords Office"
        />

      </section> */}

   

    </div>
  );
};

export default ContactPage;